import { AlertWorkSession } from './alert-work-session';

export class WorkSessionCounter {
    count: number;
}

export class WorkSession extends AlertWorkSession {
    workSessionDefinitionId: string;
    metrics: { [metricName: string]: { [metricStatisticalValue: string]: object } };
    templateName: string;
    locationId: string;
    customerId: string;
    manualActivation: boolean;
    importStatus: WorkSessionImportStatus;
    reportStorageKey: string;
    postComputationResults: { [name: string]: object };
    properties: { [name: string]: string | number };
    dataImport: HistoricalWorkSessionDataImport;
}

export enum WorkSessionImportStatus {
    IMPORTING = "IMPORTING",
    SUCCESS = "SUCCESS",
    ERROR = "ERROR"
}

export class HistoricalWorkSessionDataImport {
    storageKey: string;
}